module.exports = __webpack_public_path__ + "img/userB28.a88a361c.jpg";